import React, { useState, useRef, useEffect } from "react";
import "./Dropdownstudent.css";
import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDownUP({
  width,
  label,
  selected,
  setSelected,
  selectedLabel, // Add this prop
  setSelectedLabel, // Add this prop
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className
}) {
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    setSelected(option.id); // Pass the ID of the selected option
    setIsActive(false);
    console.log("Selected option ID:", option.id); // Log the ID of the selected option
    setSelectedLabel(option.label); // Use the prop function to set the label
  };

  return (
    <div className={`dropdown-UP-wrapper ${className}`} style={{ ...style , marginTop:"5px" }} >
      <div className="dropdown-UP-label-input" style={{ display: "flex", alignItems: "center" }}>
        <label className="dropdownUP-label" style={{ marginRight: "10px" }}>
          {label}
        </label>
        <div className="dropdown-UP" style={{ width }} ref={dropdownRef}>
          <div className="dropdown-UP-btn" onClick={() => setIsActive(!isActive)}>
            {selectedLabel}
            <img src={DropDownIcon} alt="dropdown-UP-icon" />
          </div>
          {isActive && (
            <div
              className="dropdown-UP-content"
              style={{ width: customWidth, top: customTop }}
            >
              {options.map((option) => (
                <div
                  key={option.id}
                  className="dropdown-UP-item"
                  onClick={() => handleClick(option)}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
